<template>
	<div class="container g-rela">
		<img src="@/assets/home/user-card-top-bg.png" alt="" class="user-top-bg" />
		<div class="g-rela g-flex g-row-center g-p-r-15 g-p-l-15">
			<div class="g-text-center g-full-width">
				<img :src="userInfo.avatar?userInfo.avatar:$store.state.defaultAvatar" alt="" class="avatar">
				<p class="g-row-center main-text g-weight-font">{{userInfo.realName}}</p>
				<div class="g-m-t-5 sub-text g-font-12">
					<span>{{userInfo.diplomaName}}</span>
					<span class="g-m-l-5 g-m-r-5" v-if="!!userInfo.diplomaName">|</span>
					<span v-if="!!userInfo.workingSeniorityName">{{userInfo.workingSeniorityName}}经验</span>
					<span class="g-m-l-5 g-m-r-5" v-if="!!salary">|</span>
					<span>{{salary}}</span>
				</div>
				<!--  已学习  -->
				<div class="learned-time g-rela g-m-t-14">
					<img src="@/assets/home/user-card-tag.png" class="time-tag" alt="">
					已学习{{ studyData.studyTime }}
				</div>
				<!--  成就  -->
				<div class="achievement g-flex g-m-t-16 g-row-between">
					<div class="g-text-center ach-item">
						<p class="blue-text g-font-14 g-weight-font">{{ studyData.certificateCount }} 个</p>
						<p class="g-font-12 g-m-t-2 sub-text">已获证书</p>
					</div>
					<div class="cut-line"></div>
					<div class="g-text-center ach-item">
						<p class="blue-text g-font-14 g-weight-font">{{ studyData.courseCount }} 门</p>
						<p class="g-font-12 g-m-t-2 sub-text">已学课程</p>
					</div>
					<div class="cut-line"></div>
					<div class="g-text-center ach-item">
						<p class="blue-text g-font-14 g-weight-font">{{ studyData.starCount }} 颗</p>
						<p class="g-font-12 g-m-t-2 sub-text">获得星级</p>
					</div>
				</div>
				<!-- 进入个人中心  -->
				<div class="submit-btn" @click="gotoMine">
					进入个人中心
				</div>
				<!--  公告  -->
				<div class="g-p-l-20 g-p-r-20 g-p-b-20">
					<notice-bar></notice-bar>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {resumelDetail} from "@/api/job.js"
	import {dictDetail} from "@/api/api.js"
	import {
		userInfo,
    getMyStudyInfo
	} from "@/api/user.js"
	import NoticeBar from "@/views/home/components/notice-bar";
	export default {
		name: "user-card",
		components: {
			NoticeBar
		},
		data() {
			return {
				userInfo: {},
				salary:'',
        studyData:{
          certificateCount:0, 	//证书数量
          courseCount:0, //已学课程
          starCount:0, 	//星级
          studyTime:'0小时0分钟', //学习时长
        }
			}
		},
		computed: {
			// getUserInfo(){
			// 	console.log(this.$store.state.userInfo)
			// 	return this.$store.state.isLogin

			// }
		},
		mounted() {
			this.getUserInfo();
			this.getMySalary();
			//查询学习情况
			this.queryMyStudyInfo();
		},
		methods: {

			getUserInfo(){
				userInfo({}).then(res=>{
					console.log(res)
					this.userInfo=res

				})
			},
      queryMyStudyInfo(){
        getMyStudyInfo().then(res=>{
				this.studyData =res
				})
			},
			getMySalary(){
				resumelDetail({}).then(res=>{
					if(!!res.salary){
						dictDetail({code:'salary',dictKey:res.salary}).then(res=>{
							this.salary = res.dictValue;
						})
					}
				})
			},
			gotoMine(){
				this.$router.push({
					name: 'mine'
				})
			}
			/*getUserInfo() {
				this.userInfo = this.$store.state.userInfo
			}*/
		},

	}
</script>

<style lang="scss" scoped>
	/* 阴影 */
	.container {
		background: #fff;
		border-radius: 10px;
		width: 245px;
		// height: 311px;
		height: 350px;//放下通知公告
	}

	.user-top-bg {
		width: 100%;
		height: 56px;
		border-radius: 10px;
		position: absolute;
		top: 0;
		left: 0;
	}

	.avatar {
		width: 60px;
		height: 60px;
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
		margin: 20px auto 0;
		z-index: 99;
		position: relative;
		border-radius: 50%;
	}

	.learned-time {
		color: #fff;
		font-size: 12px;
		padding: 2px 10px 2px 30px;
		border-radius: 20px;
		background: #08D1AD;
		margin: 0 20px;
		white-space: nowrap;

		.time-tag {
			position: absolute;
			top: -3px;
			left: -6px;
			width: 32px;
			height: 32px;
		}
	}

	.achievement {
		background: linear-gradient(180deg, #e9f2ff, rgba(233, 250, 255, 0.00) 100%);
		border-radius: 5px;
		box-shadow: 0 4px 4px 0 rgba(64, 122, 255, 0.08);
		padding: 6px 8px;

		.cut-line {
			width: 1px;
			height: 25px;
			background: #e9f2ff;
		}
	}

	.submit-btn {
		// margin: 25px 0 20px;
		margin: 25px 0 10px;//放下通知公告
		padding: 7px 0;
		font-size: 14px;
		border-radius: 20px;
	}
</style>
